<organization-select    #orgManager
                        autoSelectFirst = "true"
                        class           = "mr-3"
                        (change)        = "setOrg($event)"
                        ></organization-select>

                        <br>

<help-alert 
                        action      = "help.page.operator.action" 
                        info        = "help.info"
                        description = "help.page.operator.description"></help-alert>  

                        <br>
                        <br>
                        
<custom-table           #operatorTable
                        table_id            =   "operatorTable"
                        no_title_value      =   "tables.operator.no_title_value"
                        title_single        =   "tables.operator.title_single"
                        title_multiple      =   "tables.operator.title"
                        filter_title        =   "tables.operator.filter_title"
                        search_title        =   "tables.operator.search_title"
                        [columns]           =   "operatorColumns"
                        [values]            =   "values"
                        [parent]            =   "this"
                        [create]            =   "true"
                        [update]            =   "true"
                        [buttons]           =   "buttons"
                        ></custom-table>